import { FC } from 'react'

import ApprovalProvider from '@provider/Mrp/ApprovalProvider'
import DistributionProvider from '@provider/Mrp/DistributionProvider'
import OportunityProvider from '@provider/Mrp/OportunityProvider'
import PurchaseProvider from '@provider/Mrp/PurchaseProvider'
import ReabProvider from '@provider/Mrp/ReabProvider'
import ScheduledPurchaseProvider from '@provider/Mrp/ScheduledPurchaseProvider'

const MrpProviders: FC = ({ children }) => {
  return (
    <PurchaseProvider>
      <ScheduledPurchaseProvider>
        <DistributionProvider>
          <ReabProvider>
            <OportunityProvider>
              <ApprovalProvider>{children}</ApprovalProvider>
            </OportunityProvider>
          </ReabProvider>
        </DistributionProvider>
      </ScheduledPurchaseProvider>
    </PurchaseProvider>
  )
}

export default MrpProviders
